var React = require('react');

function IconCompass (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"}));
}

IconCompass.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = IconCompass;

IconCompass.default = IconCompass;
